import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { subPanelVariants } from "./SubPanel.variants.js";
function SubPanel({ children, position = 'top', emphasis = 'none', className, slots = {} }) {
    const { containerSlot, subPanelSlot } = subPanelVariants({
        position,
        emphasis
    });
    const containerClass = cn(containerSlot(), slots.containerSlot, className);
    const subPanelClass = cn(subPanelSlot(), slots.subPanelSlot);
    return /*#__PURE__*/ jsx("div", {
        className: containerClass,
        children: /*#__PURE__*/ jsx("div", {
            className: subPanelClass,
            children: children
        })
    });
}
export { SubPanel };
